import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../../context-store";
import Layout from "../../../components/layout/Layout";
import "../../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../../assets/InnerCSS/css/styles.css";
import "../../../assets/InnerCSS/css/custom.css";
import InterviewerSchedulesComponent from "../../../components/admin/interviewer/interviewer-schedules/InterviewerSchedulesComponent";
import IdNameModel from "../../../models/common/IdNameModel";
import toasterUtils from "../../../utils/toaster-utils";
import modalUtils from "../../../utils/modal-utils";
import { useHistory } from "react-router";
import masterDataService from "../../../services/master-data-service";

const InterviewerSchedules = () => {
    const history = useHistory();
    const [primarySkillList, setPrimarySkillList] = useState<IdNameModel[]>([]);
    const [refreshSkills, setRefreshSkills] = useState<number>(2);
    const [timeSlots, setTimeSlots] = useState<IdNameModel[]>([]);
    const [refreshTimeSlots, setRefreshTimeSlots] = useState<number>(2);

    useEffect(() => {
        fillPrimarySkills();
        getTimeSlots();
    }, []);

    const fillPrimarySkills = () => {
        setRefreshSkills(2);
        masterDataService.loadPrimarySkills().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setPrimarySkillList(res.items);
            setRefreshSkills(refreshSkills * 5);
        }).catch((error) => {
            setRefreshSkills(refreshSkills * 5);
            toasterUtils.showError(error);
        });
    };

    const getTimeSlots = () => {
        setRefreshTimeSlots(2);
        modalUtils.showLoader();
        masterDataService.loadTimeSlots().then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setTimeSlots(res.items);
            setRefreshTimeSlots(refreshTimeSlots * 5);
        }).catch((error) => {
            setRefreshTimeSlots(refreshTimeSlots * 5);
            modalUtils.closeModal();
            toasterUtils.showError("Erorr fetching Time Slots");
        });
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> Interviewer Schedules
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> Interviewer Schedule </h4>
            </div>
            {refreshSkills > 2 && refreshTimeSlots > 2 &&
                <InterviewerSchedulesComponent primarySkillsList={primarySkillList} timeSlotsList={timeSlots} />
            }
        </Layout>
    );
};
export default InterviewerSchedules;